// 🧿 طلسم محافظ فایل

import React from "react";
// UI Framework
import { toast } from "react-toastify";
import { TableCell, TableRow } from "@mui/material";
// Common components
import {
  Button,
  TextInput,
  FullScreenLoading,
  ToggleSwitch,
} from "src/Components";
import Table from "src/Components/Table";
// Requests
import { getExeConfig, setExeConfig } from "src/Requests/automaticMarketMaking";
// Types
import {
  IBaseInsTolerance,
  IExeConfigDto,
} from "src/Interfaces/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
}

const SettingConfig = ({ onClose }: IProps) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [config, setConfig] = React.useState({
    baseInsTolerance: [] as IBaseInsTolerance[],
  } as IExeConfigDto);

  React.useEffect(() => {
    setLoading(true);

    getExeConfig()
      .then((resp) => {
        setConfig(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const instrumentChangeHandler = (insId: string, name: string, value: any) => {
    const targetIndex = config.baseInsTolerance.findIndex(
      (f) => f.baseInsId === insId,
    );
    if (targetIndex === -1) return;
    const clone = [...config.baseInsTolerance];
    clone.splice(targetIndex, 1, {
      ...config.baseInsTolerance[targetIndex],
      [name]: value,
    });
    setConfig({
      ...config,
      baseInsTolerance: [...clone],
    });
  };

  const setConfigHandler = () => {
    setLoading(true);
    setExeConfig(config)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const header = () => (
    <>
      <TableCell />
      <TableCell>دلتای کم</TableCell>
      <TableCell>دلتای خنثی</TableCell>
      <TableCell>دلتای زیاد</TableCell>
    </>
  );

  const body = (type: "put" | "call") => (
    <>
      <TableRow>
        <TableCell>٪ کاهش IV</TableCell>
        <TableCell>
          <div className="flex flex-row justify-around items-center my-1">
            <span>پله اول</span>
            <span>پله دوم</span>
          </div>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای کم پله اول"
              name="lowDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      lowDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      lowDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.lowDeltaStepOne?.toString() || ""
                  : config?.putDecreaseIVUnit?.lowDeltaStepOne?.toString() || ""
              }
            />
            <TextInput
              label="دلتای کم پله دوم"
              name="lowDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      lowDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      lowDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.lowDeltaStepTwo?.toString() || ""
                  : config?.putDecreaseIVUnit?.lowDeltaStepTwo?.toString() || ""
              }
            />
          </div>
        </TableCell>
        <TableCell>
          <div className="flex flex-row justify-around items-center my-1">
            <span>پله اول</span>
            <span>پله دوم</span>
          </div>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای خنثی پله اول"
              name="neturalDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      neturalDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      neturalDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.neturalDeltaStepOne?.toString() ||
                    ""
                  : config?.putDecreaseIVUnit?.neturalDeltaStepOne?.toString() ||
                    ""
              }
            />
            <TextInput
              label="دلتای خنثی پله دوم"
              name="neturalDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      neturalDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      neturalDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.neturalDeltaStepTwo?.toString() ||
                    ""
                  : config?.putDecreaseIVUnit?.neturalDeltaStepTwo?.toString() ||
                    ""
              }
            />
          </div>
        </TableCell>
        <TableCell>
          <div className="flex flex-row justify-around items-center my-1">
            <span>پله اول</span>
            <span>پله دوم</span>
          </div>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای زیاد پله اول"
              name="highDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      highDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      highDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.highDeltaStepOne?.toString() || ""
                  : config?.putDecreaseIVUnit?.highDeltaStepOne?.toString() ||
                    ""
              }
            />
            <TextInput
              label="دلتای زیاد پله دوم"
              name="highDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    decreaseIVUnit: {
                      ...config.decreaseIVUnit,
                      highDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putDecreaseIVUnit: {
                      ...config.putDecreaseIVUnit,
                      highDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.decreaseIVUnit?.highDeltaStepTwo?.toString() || ""
                  : config?.putDecreaseIVUnit?.highDeltaStepTwo?.toString() ||
                    ""
              }
            />
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>٪ افزایش IV</TableCell>
        <TableCell>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای کم پله اول"
              name="lowDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      lowDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      lowDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.lowDeltaStepOne?.toString() || ""
                  : config?.putIncreaseIVUnit?.lowDeltaStepOne?.toString() || ""
              }
            />
            <TextInput
              label="دلتای کم پله دوم"
              name="lowDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      lowDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      lowDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.lowDeltaStepTwo?.toString() || ""
                  : config?.putIncreaseIVUnit?.lowDeltaStepTwo?.toString() || ""
              }
            />
          </div>
        </TableCell>
        <TableCell>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای خنثی پله اول"
              name="neturalDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      neturalDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      neturalDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.neturalDeltaStepOne?.toString() ||
                    ""
                  : config?.putIncreaseIVUnit?.neturalDeltaStepOne?.toString() ||
                    ""
              }
            />
            <TextInput
              label="دلتای خنثی پله دوم"
              name="neturalDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      neturalDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      neturalDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.neturalDeltaStepTwo?.toString() ||
                    ""
                  : config?.putIncreaseIVUnit?.neturalDeltaStepTwo?.toString() ||
                    ""
              }
            />
          </div>
        </TableCell>
        <TableCell>
          <div className="flex flex-row gap-2">
            <TextInput
              label="دلتای زیاد پله اول"
              name="highDeltaStepOne"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      highDeltaStepOne: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      highDeltaStepOne: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.highDeltaStepOne?.toString() || ""
                  : config?.putIncreaseIVUnit?.highDeltaStepOne?.toString() ||
                    ""
              }
            />
            <TextInput
              label="دلتای زیاد پله دوم"
              name="highDeltaStepTwo"
              onChange={(name: string, value: string) => {
                if (type === "call") {
                  setConfig({
                    ...config,
                    increaseIVUnit: {
                      ...config.increaseIVUnit,
                      highDeltaStepTwo: value,
                    },
                  });
                } else {
                  setConfig({
                    ...config,
                    putIncreaseIVUnit: {
                      ...config.putIncreaseIVUnit,
                      highDeltaStepTwo: value,
                    },
                  });
                }
              }}
              value={
                type === "call"
                  ? config?.increaseIVUnit?.highDeltaStepTwo?.toString() || ""
                  : config?.putIncreaseIVUnit?.highDeltaStepTwo?.toString() ||
                    ""
              }
            />
          </div>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <div className="w-full flex flex-col justify-start items-center gap-5">
      {loading ? <FullScreenLoading /> : <></>}
      <div className="w-fit ml-auto flex gap-2">
        <div className="w-[200px]">
          <TextInput
            label="٪ نرخ بهره کال"
            name="callRiskFreeRate"
            onChange={changeHandler}
            value={
              config?.callRiskFreeRate?.toString() ||
              config?.riskFreeRate?.toString() ||
              ""
            }
            kind="percent"
            extraLabel
          />
        </div>
        <div className="w-[200px]">
          <TextInput
            label="٪ نرخ بهره پوت"
            name="putRiskFreeRate"
            onChange={changeHandler}
            value={
              config?.putRiskFreeRate?.toString() ||
              config?.riskFreeRate?.toString() ||
              ""
            }
            kind="percent"
            extraLabel
          />
        </div>
      </div>
      <div className="w-full grid grid-cols-6 gap-x-1 gap-y-3 text-sm">
        <div>نماد پایه</div>
        <div>٪دلتای هدف </div>
        <div>٪تلورانس دلتا </div>
        <div>حجم پله اول تغییر IV</div>
        <div>حجم پله دوم تغییر IV</div>
        <div>الزام فعال بودن کال متناظر برای ارسال پوت</div>
        {config && config.baseInsTolerance && config.baseInsTolerance.length ? (
          config.baseInsTolerance.map((ins) => (
            <>
              <div>{ins.baseInsName}</div>
              <TextInput
                label="٪ دلتای هدف"
                name="targetDelta"
                value={ins?.targetDelta?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                kind="percent"
              />
              <TextInput
                label="٪ تلورانس دلتا"
                name="deltaTolerance"
                value={ins.deltaTolerance?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                kind="percent"
              />
              <TextInput
                label="حجم پله اول تغییر IV"
                name="ivStepOneTradeVolume"
                value={ins?.ivStepOneTradeVolume?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                kind="priceWithDecimal"
              />
              <TextInput
                label="حجم پله دوم تغییر IV"
                name="ivStepTwoTradeVolume"
                value={ins?.ivStepTwoTradeVolume?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                kind="priceWithDecimal"
              />
              <ToggleSwitch
                checked={ins?.isCallRequired}
                label=""
                name="isCallRequired"
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
              />
            </>
          ))
        ) : (
          <></>
        )}
      </div>
      <div className="w-full pl-96">
        <span className="w-full ml-0 mt-5">تغییر IV کال</span>
        <div className="w-full m-auto rounded overflow-hidden order-table mt-3 mb-6">
          <Table header={header()} body={body("call")} />
        </div>
        <span className="w-full ml-0  mt-5">تغییر IV پوت</span>
        <div className="w-full m-auto rounded overflow-hidden order-table mt-3 mb-6">
          <Table header={header()} body={body("put")} />
        </div>
        <div className="flex flex-row w-full gap-2">
          <div className="w-[200px] ml-auto">
            <TextInput
              label="زمان معتبر بودن IV در توقف (دقیقه)"
              name="ivExpirationTime"
              onChange={changeHandler}
              value={config?.ivExpirationTime?.toString() || ""}
              extraLabel
              kind="priceWithDecimal"
            />
          </div>
          <div className="w-[200px] ml-auto">
            <TextInput
              label="حداقل ٪ سرمایه درگیر به ارزش پورتفو"
              name="involvedFundToPortfovalueMinRatio"
              onChange={changeHandler}
              value={
                config?.involvedFundToPortfovalueMinRatio?.toString() || ""
              }
              extraLabel
              kind="percent"
            />
          </div>
          <div className="w-[200px] ml-auto">
            <TextInput
              label="حداکثر ٪ تغییر قیمت تعادلی در دو تریگر متوالی"
              name="maxFairpriceChangePercentage"
              onChange={changeHandler}
              value={config?.maxFairpriceChangePercentage?.toString() || ""}
              extraLabel
              kind="percent"
              allowPercentAbove100
            />
          </div>
          <div className="w-[260px] ml-auto">
            <TextInput
              label="حداقل قدرت خرید اختیار برای سفارش گذاری کامل"
              name="minOptionPower"
              onChange={changeHandler}
              value={config?.minOptionPower?.toString() || ""}
              extraLabel
              kind="priceWithDecimal"
            />
          </div>
          <div className="w-[200px] ml-auto">
            <div className="text-[10px] whitespace-nowrap w-auto">
              حذف سفارشات مضاعف
            </div>
            <ToggleSwitch
              checked={config?.removeExtraOrders}
              label=""
              name="removeExtraOrders"
              onChange={changeHandler}
            />
          </div>
        </div>
      </div>
      <div className="w-[100px] mr-auto">
        <Button onClick={setConfigHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );
};

export default SettingConfig;
